import React from 'react';
import { gettext } from '@eventbrite/i18n';

import { Photo } from '@eb/eds-iconography';
import { Money } from '@eb/eds-iconography';
import { Globe } from '@eb/eds-iconography';
import { ScanCheck } from '@eb/eds-iconography';
import { CreditCardBack } from '@eb/eds-iconography';
import { LineChart } from '@eb/eds-iconography';

// new brand overview page translations
// TODO: Delete duplicate translations

export const TRANSFORM_VISION = gettext(
    'From music festivals and conventions to pop-up dinners and photography classes, transform your vision into an experience people will love.',
);

export const GET_STARTED_MINUTES = gettext('Get started in minutes');
export const CREATE_LISTING = gettext(
    'Create a beautiful event listing page with built-in payment processing, analytics, and support.',
);
export const CHOOSE_SOLUTION = gettext('Choose a solution');
export const GET_STARTED = gettext('Get started');
export const CREATE_AN_EVENT = gettext('Create an event');

export const TAKE_CONTROL = gettext('Take control');
export const TRACK_ANALYTICS = gettext(
    'Manage and track your sales with real time reporting and analytics from any device.',
);
export const ELEVATE_BRAND = gettext('Elevate your brand');
export const PROMOTE_BRAND = gettext(
    'Promote your unique brand with beautifully designed pages that enable easy discovery and ticket purchasing.',
);

export const GATHER_TRIBE = gettext('Gather your tribe');
export const EXTEND_REACH = gettext(
    'Extend your reach and find your audience where they discover experiences on partner sites like Facebook, Instagram and Spotify.',
);

export const MAKE_EXPERIENCE = gettext('Make your event an experience');
export const ONSITE_LOGISTICS = gettext(
    'Give your event goers a great experience with simple, secure checkout and rapid check-in through our mobile apps and a full suite of on-site equipment, staffing, and logistics.',
);
export const RULE_DAYOF = gettext('Rule the day-of');
export const ONSITE_PLANNING = gettext(
    'We can help with on-site planning and consultation. <a href="/contact-sales">Contact us</a> to learn more.',
);

export const GET_STARTED_SOLUTION = gettext(
    'Get started with the perfect solution for your event',
);
export const GET_DETAILS = gettext('Get the details');
export const VIEW_PRICING = gettext('View pricing');

export const PASS_FEES_ON_SECONDARY_HEADER = gettext(
    'Use Eventbrite for free, by passing the fees to your attendees',
);
export const ESSENTIALS_DESCRIPTION = gettext(
    'The solution to start selling tickets quickly and easily',
);
export const PROFESSIONAL_DESCRIPTION = gettext(
    'All features that you need to market your events and grow your business',
);
export const UK_PROFESSIONAL_DESCRIPTION = gettext(
    'A powerful solution to boost sales and grow your business',
);
export const PREMIUM_DESCRIPTION = gettext(
    'Customized solution for large and complex events',
);
export const PRICE_DESCRIPTION = gettext('No fees for free tickets');

// features
const PAYMENT_PROCESSING = gettext('Eventbrite Payment Processing');
const PAID_OUT_QUICK = gettext(
    'Let your attendees pay online, and get paid out quickly.',
);
const FREE_ALWAYS = gettext('Free tickets are always free');
const NO_FEE_FREE = gettext('We never charge fees on free tickets.');
const ORGANIZER_APP = gettext('An app designed for organizers');
const EVENTS_ON_MOBILE = gettext(
    'Run, promote, and track your event from your mobile device.',
);
const OUT_OF_BOX_LISTINGS = gettext('Professional out-of-the-box listing page');
const BEAUTIFULLY_DESIGNED_PAGE = gettext(
    'Up your game with a beautifully designed event page.',
);
const EMBED_CHECKOUT = gettext('Embed checkout on your own site');
const EASY_CHECKOUT = gettext(
    'Give your website visitors an easy checkout experience and keep them on your site.',
);
const CUSTOM_BRANDED_SITE = gettext('Create a custom branded website');
const WEB_PRESENCE = gettext(
    'Build your own landing page using our self-service Eventbrite Studio tools.',
);
const MILLIONS_EVENT_GOERS = gettext('Event goers all over the world');
const REACH_MILLIONS = gettext(
    'Three million events in 170+ countries in 2017.',
);
const INDUSTRY_LEADING = gettext('Industry leading search ranking');
const TOP_GOOGLE_SEARCH = gettext(
    'Show up on top of Google search results with our top ranked SEO.',
);
const FB_IG_INTEGRATION = gettext('Facebook and Instagram integration');
const BE_SOCIAL = gettext(
    'Be social and sell tickets on the sites where people love to gather.',
);
const MOBILE_SCANNING = gettext('Easy to use mobile ticket scanning');
const ATTENDEES_FAST = gettext('Get your attendees in the door fast.');
const SELL_MORE_DOOR = gettext('Sell more at the door');
const ACCEPT_MONEY_PRINT_TIX = gettext(
    'Accept credit cards and cash, look up orders, and print tickets.',
);
const FINGER_PULSE = gettext('Keep your finger on the pulse');
const MAKE_DECISIONS = gettext(
    'Make informed decisions with data, insights, and reports.',
);
const EQUIPMENT_RENTALS = gettext('Equipment rentals');
const NEXT_LEVEL = gettext(
    'Take your operations to the next level with mobile box office tech kits.',
);
const STAFFING_LOGISTICS = gettext('Staffing & logistics');
const EXTRA_HANDS = gettext('Put extra hands or a full staff to work.');
const DEDICATED_SUCCESS = gettext('Dedicated success manager');
const EVENT_PRO_BENEFIT = gettext(
    'Benefit from the event expertise of a seasoned pro.',
);

export const PAYMENT_PROCESSING_FEATURE = {
    heading: PAYMENT_PROCESSING,
    description: PAID_OUT_QUICK,
    imagePath: 'overview/img-sm-epp',
};
export const FREE_ALWAYS_FREE_FEATURE = {
    heading: FREE_ALWAYS,
    description: NO_FEE_FREE,
    imagePath: 'overview/img-sm-dance',
};
export const ORGANIZER_APP_FEATURE = {
    heading: ORGANIZER_APP,
    description: EVENTS_ON_MOBILE,
    imagePath: 'overview/img-sm-orgApp',
};
export const LISTING_PAGE_FEATURE = {
    heading: OUT_OF_BOX_LISTINGS,
    description: BEAUTIFULLY_DESIGNED_PAGE,
    iconType: <Photo />,
    imagePath: 'overview/img-brand-listing',
};
export const CHECKOUT_FEATURE = {
    heading: EMBED_CHECKOUT,
    description: EASY_CHECKOUT,
    iconType: <Money />,
    imagePath: 'overview/img-brand-checkout',
};
export const CUSTOM_SITE_FEATURE = {
    heading: CUSTOM_BRANDED_SITE,
    description: WEB_PRESENCE,
    iconType: <Globe />,
    imagePath: 'overview/img-brand-checkout',
};
export const MILLIONS_FEATURE = {
    heading: MILLIONS_EVENT_GOERS,
    description: REACH_MILLIONS,
    imagePath: 'overview/img-sm-millions',
};
export const LEADING_SEARCH_FEATURE = {
    heading: INDUSTRY_LEADING,
    description: TOP_GOOGLE_SEARCH,
    imagePath: 'overview/img-sm-google',
};
export const INTEGRATION_FEATURE = {
    heading: FB_IG_INTEGRATION,
    description: BE_SOCIAL,
    imagePath: 'overview/img-sm-facebook',
};

export const MOBILE_FEATURE = {
    heading: MOBILE_SCANNING,
    description: ATTENDEES_FAST,
    iconType: <ScanCheck />,
};
export const SELL_FEATURE = {
    heading: SELL_MORE_DOOR,
    description: ACCEPT_MONEY_PRINT_TIX,
    iconType: <CreditCardBack />,
};
export const DECISION_MAKING_FEATURE = {
    heading: FINGER_PULSE,
    description: MAKE_DECISIONS,
    iconType: <LineChart />,
};

export const EQUIPMENT_RENTALS_FEATURE = {
    heading: EQUIPMENT_RENTALS,
    description: NEXT_LEVEL,
    imagePath: 'overview/img-onsite-equipment',
};
export const STAFFING_FEATURE = {
    heading: STAFFING_LOGISTICS,
    description: EXTRA_HANDS,
    imagePath: 'overview/img-onsite-staff',
};
export const MANAGER_FEATURE = {
    heading: DEDICATED_SUCCESS,
    description: EVENT_PRO_BENEFIT,
    imagePath: 'overview/img-onsite-manager',
};
